module.exports = __webpack_public_path__ + "static/media/credit-card.c6bb9c15.svg";